import React, { useState } from 'react'
import { Card } from 'primereact/card'
import { alergenosEnum } from '../interface/alergenos';
import { AlergenoIcon } from './AlergenoIcon';
import { Image } from 'primereact/image';
import { IItemInterface } from '../data/dataInterface';
import './ProductMinimo.css';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';


export const ProductMinimo = (Props: IItemInterface) => {

    const [displayBasic, setDisplayBasic] = useState(false);
    
    const onHide = () => {
        setDisplayBasic(false);
    }

    const renderFooter = () => {
        return (
            <div>
                {/* <Button label="Cerrar" icon="pi pi-check" onClick={() => onHide()} autoFocus /> */}
            </div>
        );
    }

    const handleDescription = (Props: IItemInterface) => {
        //console.log(Props.description);
        setDisplayBasic(true);
    }

    const header = <img alt={""} src={Props.image} loading="lazy" width="100" height="100" onClick={() => handleDescription(Props)}/>;
    const footer = 
        <div className="flex flex-row justify-content-center flex-wrap my-5">
            {
                Props.alergenos.map((alergeno: alergenosEnum) => {
                    return <AlergenoIcon key={Props.indicator+alergeno} nameIcon={alergeno} width="20"/>
                })
            }
        </div>;
    
    var title = <><span onClick={() => handleDescription(Props)}>{Props.indicator + ". " + Props.name}</span></>;

    if (Props.limit) {
        title = <>
                    <span onClick={() => handleDescription(Props)}>{Props.indicator + ". " + Props.name}
                    </span>
                    <br></br>
                    <span className="limit">{Props.limit}
                    </span>
                </>;
    }
    return (
        <>            
            <Card className="p-card" title={title} header={header}
                style={{ 
                    width: '100px',
                    margin: 'auto',
                    marginTop: '10px',
                    height: '175px'
                }}
                key={Props.indicator}
                >                              
            </Card>
            <Dialog header={Props.indicator + ". " + Props.name} visible={displayBasic} style={{}} onHide={() => onHide()} position="left" modal={true}>
                    <img alt={""} src={Props.image} loading="lazy" width="300" height="300" />
                    <p>{Props.description}</p>
                    <p style={{
                        alignContent: 'center',
                        color: '#f00'
                    }}>{Props.limit ? 'Limitado a: ' + Props.limit : ''}</p>
                    <div className="flex flex-row justify-content-center flex-wrap my-5">
                        {
                            Props.alergenos.map((alergeno: alergenosEnum) => {
                                return <AlergenoIcon key={Props.indicator+alergeno} nameIcon={alergeno} width="30"/>
                            })
                        }
                    </div>
            </Dialog>
        </>

    )
}
